import React from "react";
import { AppBar, Box, Container } from "@mui/material";
import NavLinkItem from "./NavLinkItem";
import ZHP from "../assets/images/ZHP_ID.svg";
import { menuItems } from "./menuItems";
import LoginNavItem from "./LoginNavItem";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

export default function StickyHeader({ visible }) {
  const { accounts } = useMsal();
  const navigate = useNavigate();

  if (!visible) return null;

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={3}
      sx={{
        top: 0,
        backgroundColor: "white",
        zIndex: (theme) => theme.zIndex.appBar + 1,
        py: 2,
        transition: "transform 0.3s",
      }}
    >
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={ZHP}
            alt="Identyfikator Związku Harcerstwa Polskiego"
            style={{ height: 56, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </Box>

        <Box sx={{ display: "flex", gap: 3 }}>
          {menuItems.map((item) => (
            <NavLinkItem key={item.to} label={item.label} to={item.to} />
          ))}
          {accounts.length > 0 && (
            <NavLinkItem label="Lista zgłoszeń" to="/lista" />
          )}
          <LoginNavItem />
        </Box>
      </Container>
    </AppBar>
  );
}
